import { ReactNode } from 'react';
import styled from 'styled-components';

import { BaseStatisticsMessage } from '../../../types/StatisticsMessage';
import { Text } from '../../cdl/Text/Text';
import { formatMoney } from '../../common/helpers/formatMoney.helper';
import { formatNumber } from '../../common/helpers/formatNumber.helper';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';
import { theme } from '../../common/ui/theme';

const StatsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);

    @media (max-width: ${theme.breakpoints.lg}) {
        grid-template-columns: 1fr;
        row-gap: ${theme.space[24]};
    }
`;

interface StatsItemProps {
    label: string;
    children: ReactNode;
}

const StatsItem = ({ label, children }: StatsItemProps) => {
    return (
        <Box display="flex" flexDirection="column">
            <Text variant="headline">{children}</Text>
            <Text variant="fieldLabel">{label}</Text>
        </Box>
    );
};

interface GeneralStatsProps {
    statisticsData: BaseStatisticsMessage['general'];
}

export const GeneralStats = ({ statisticsData }: GeneralStatsProps) => {
    return (
        <StatsGrid>
            <StatsItem label={translate('reporting.general.deliveries')}>
                {formatNumber({
                    number: statisticsData.completedCount,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                })}
            </StatsItem>

            <StatsItem label={translate('reporting.general.volumes')}>
                {formatNumber({
                    number: statisticsData.volume,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                })}
                &nbsp; L
            </StatsItem>

            <StatsItem label={translate('reporting.general.ppl')}>
                {formatMoney({
                    value: statisticsData.ppl.value,
                    currency: statisticsData.ppl.currency,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}
            </StatsItem>

            <StatsItem label={translate('reporting.general.costs')}>
                {formatMoney({
                    value: statisticsData.total.value,
                    currency: statisticsData.total.currency,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}
            </StatsItem>
        </StatsGrid>
    );
};
